let czWebUrl = 'https://dev.o2fs.app/';
let huWebUrl = 'https://hu.dev.o2fs.app/';
let skWebUrl = 'https://sk.dev.o2fs.app/';

let czWebWhistleblowingUrl ='https://dev.o2fs.app/whistleblowing';

if (process.env.REACT_APP_CZ_WEB_URL) {
  czWebUrl = process.env.REACT_APP_CZ_WEB_URL;
}

if (process.env.REACT_APP_HU_WEB_URL) {
  huWebUrl = process.env.REACT_APP_HU_WEB_URL;
}

if (process.env.REACT_APP_SK_WEB_URL) {
  skWebUrl = process.env.REACT_APP_SK_WEB_URL;
}

if (process.env.REACT_APP_CZ_WEB_WHISTLEBLOWING_URL) {
  czWebWhistleblowingUrl = process.env.REACT_APP_CZ_WEB_WHISTLEBLOWING_URL;
}

export default { czWebUrl, huWebUrl, skWebUrl, czWebWhistleblowingUrl };
